exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alp-tag{background:#c9462c;border-radius:3px;border:1px solid hsla(0,0%,100%,.5);color:#fff;display:inline-block;font-family:Montserrat,sans-serif;font-size:16px;font-weight:600;padding:5px 10px;transform:rotate(-5deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e70dcd2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Tag.vue
// module id = 61
// module chunks = 0